import { FC } from "react"
import { Navigate, useLocation } from "react-router-dom"

const InaccessibleRoute: FC = () => {
  const location = useLocation()

  return <Navigate to="/" state={{ from: location }} replace />
}

export default InaccessibleRoute
